import React from 'react'
import CourseRegisterSection from '../components/Forms/CourseRegisterSection'
import NavBar from '../components/Navbar/NavBar'
import Footer from '../components/Footer/Footer'


function CourseRegister() {
  return (
    <div>
      <NavBar/>
        <CourseRegisterSection/>
        <Footer/>

    </div>
  )
}

export default CourseRegister